import React, { PureComponent } from 'react'
import { wrapDisplayName } from 'recompose'
import { connect } from 'react-redux'
import { uiConfigureTopBar, uiClearConfigureTopBar } from '../../actions'

function withTopBar(config) {
  return function(WrappedComponent) {
    class EnhanceComponent extends PureComponent {
      componentDidMount() {
        const { match } = this.props
        this.props.uiConfigureTopBar({ ...config, match })
      }

      componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
          this.props.uiConfigureTopBar({ match: nextProps.match })
        }
      }

      componentWillUnmount() {
        this.props.uiClearConfigureTopBar(config)
      }

      topBarSetTitle = title =>
        this.props.uiConfigureTopBar({
          title,
        })

      topBarOpenFilters = () =>
        this.props.uiConfigureTopBar({
          openFilters: true,
        })

      topBarCloseFilters = () =>
        this.props.uiConfigureTopBar({
          openFilters: false,
        })

      render() {
        const passProps = {
          ...this.props,
          topBarSetTitle: this.topBarSetTitle,
          topBarCloseFilters: this.topBarCloseFilters,
          topBarOpenFilters: this.topBarOpenFilters,
        }
        return <WrappedComponent {...passProps} />
      }
    }

    const TopBarComponent = connect(undefined, {
      uiConfigureTopBar,
      uiClearConfigureTopBar,
    })(EnhanceComponent)

    if (process.env.NODE_ENV !== 'production') {
      TopBarComponent.displayName = wrapDisplayName(
        TopBarComponent,
        'withTopBar'
      )
    }

    return TopBarComponent
  }
}

export default withTopBar



// WEBPACK FOOTER //
// ./src/common/TopBar/withTopBar.js